<template>
  <div class="unreport-link">
    <div class="link" @click="unreportPost()">
      <span>{{ $t('administrator.unreportPost.unreport') }}</span>
    </div>
    <modal-confirm
      class="confirm-unreport"
      @click.stop
      @confirm="unreport()"
      @close="closeModal()"
      :cancel="$t('administrator.unreportPost.no')"
      :confirm="$t('administrator.unreportPost.yes')"
      :title="$t('administrator.unreportPost.unreportPost')"
      :message="$t('administrator.unreportPost.unreportConfirmation')"
      :show-modal="showModal"
    />
  </div>
</template>

<script>
import ModalConfirm from '@/components/shared/ModalConfirm'

export default {
  name: 'UnreportPost',
  components: { ModalConfirm },
  props: {
    post: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      showModal: false
    }
  },
  methods: {
    unreportPost () {
      this.showModal = true
    },
    closeModal () {
      this.showModal = false
    },
    async unreport () {
      this.closeModal()
      let message = this.$t('administrator.unreportPost.postUnreported')
      let success = await this.$store.dispatch('unreportPost', this.post)
      if (success) {
        this.$toasted.global.success(message)
      }
    }
  }
}
</script>

<style scoped lang="scss">
  .unreport-link {
    width: 100%;
    .link {
        color: $primary-color;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        -ms-flex-pack: start;
        justify-content: flex-start;
        align-items: center;
        padding: 4px 12px;

        &:hover  {
          cursor: pointer;
          background-color: $primary-color;
          color: white;
        }
      }
  }
</style>
